import { Component, Input } from '@angular/core';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ModalService } from '@services/modal/modal.service';

@Component({
  selector: 'ts-carrier-validation',
  templateUrl: './carrier-validation.component.html',
  imports: [TranslationPipe]
})
export class CarrierValidationComponent {
  @Input() modal_header: string;
  @Input() modal_body: string;

  constructor(private modal_service: ModalService) {}

  dismissModal(): void {
    this.modal_service.dismissLastModal('Close click');
  }
}
